import { accentColors } from '@tryhackme/thm-ui-components';
import { StepperModal } from 'src/common/components/stepper/stepper-modal';
import styled from 'styled-components';
export const StyledStepperModal = styled(StepperModal)<{
  $isMobile: boolean;
}>`
  overflow-y: auto;
  @media screen and (min-width: ${({
  theme
}) => theme.sizes.md}) {height: 63rem;}
`;
export const StyledProgressBar = styled.div<{
  ammountOfSteps: number;
  currentStep: number;
  $isDarkMode: boolean;
}>`
  width: 37.5rem;
  height: 0.5rem;
  background: #B8BEC9;
  opacity: 0.9;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: ${({
  ammountOfSteps,
  currentStep
}) => `${Math.min(100, Math.max(0, currentStep / Math.max(1, ammountOfSteps) * 100))}%`};
    height: 100%;
    background: ${({
  theme,
  $isDarkMode
}) => $isDarkMode ? theme.colors.primary.main : accentColors.success.light};
  }

  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const StyledButtonRow = styled.div<{
  $isMobile?: boolean;
}>`
  display: flex;
  gap: 1.6rem;

  @media (max-width: 768px) {
		flex-direction: column-reverse;
		width: 100%;

		& > * {
			width: 100%;
		}
	}
`;
export const StyledBottomRow = styled.div<{
  $isMobile?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 3.2rem;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;